import { JsonPipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { AutoSelect } from 'src/app/Models/auto-select';
import { ApiService } from 'src/app/Services/api.services';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  asegurado: Asegurado;
  autos: AutoSelect [] = [];
  urlAseguradora: string;
  @Output()
  patente = new EventEmitter<string>();

  constructor(private apiService: ApiService, private router: Router) {
    this.autos = JSON.parse(localStorage.getItem('dataSelectAutos'));
  }

  ngOnInit(): void {
  }

  onChangeCar(idPolizaConcatIdVoucher: string): void{
    console.log('El select de la patente cambioo a esto: ', idPolizaConcatIdVoucher);
    this.urlAseguradora = localStorage.getItem('urlAseguradora');

    const idPolizaConcatIdVoucherArray = idPolizaConcatIdVoucher.split('-');
    const idPoliza = idPolizaConcatIdVoucherArray[0];
    const idVoucher = idPolizaConcatIdVoucherArray[1];

    console.log('idpoliza es:' , idPoliza);
    console.log('idVoucher es:' , idVoucher);

    localStorage.setItem('firstIdVoucher', idVoucher);
    this.router.navigate(['/seguro', idPoliza]);
  }

}
